@if ({ info: hotListInfo$ | async, showIcon: showAlmostHotIcon$ | async }; as
hotList) { @if (hotList.info?.hot || (hotList.info?.almostHot &&
hotList?.showIcon)) {
<div
  class="icon-circle d-flex justify-content-center align-items-center mr-2"
  [class.almost-hot]="hotList.info?.almostHot"
  [atxTooltip]="toolTipText$ | async"
>
  <fa-icon [icon]="['fas', 'fire-flame-curved']"></fa-icon>
</div>
} }
